export default "__VITE_ASSET__CTL8B9pa__"